/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IdWithOrderDto } from './IdWithOrderDto';
import type { OfferItemDetails } from './OfferItemDetails';
import type { OfferTranslationUpdate } from './OfferTranslationUpdate';

export type OfferUpdate = {
    name?: string;
    effectiveFrom?: string;
    effectiveTo?: string;
    displayFrom?: string;
    receiptAcceptanceDaysThreshold?: number;
    priceLow?: number;
    priceHigh?: number;
    quantity?: number;
    regions?: Array<'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'ON' | 'TB' | 'PE' | 'QC' | 'SK' | 'YT'>;
    maxRedeemsPerCollector?: number;
    displayRetailers?: Array<IdWithOrderDto>;
    isExclusiveForRetailer?: boolean;
    translations?: Array<OfferTranslationUpdate>;
    displayPriorityZoneId?: number;
    miles?: number;
    offerCode?: string;
    sponsorCode?: string;
    rewardScope?: OfferUpdate.rewardScope;
    rewardType?: OfferUpdate.rewardType;
    items?: Array<OfferItemDetails>;
    isRiceCalculationEnabled?: boolean;
};

export namespace OfferUpdate {

    export enum rewardScope {
        RECEIPT = 'RECEIPT',
        LINE_ITEM = 'LINE_ITEM',
    }

    export enum rewardType {
        FIXED_VALUE = 'FIXED_VALUE',
        PER_DOLLAR_SPENT = 'PER_DOLLAR_SPENT',
    }


}

